export default __webpack_public_path__ + "imgs/GoToBuyLotteryIcon.png";